import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "emptyState"]
  static values = {
    fieldName: { type: String, default: "user" }
  }

  connect() {
    this.updateEmptyState()
  }

  add(event) {
    event.preventDefault()
    
    const index = this.containerTarget.querySelectorAll('.custom-link-item').length
    const template = this.templateTarget.innerHTML.replace(/INDEX/g, index)
    
    this.containerTarget.insertAdjacentHTML('beforeend', template)
    this.updateEmptyState()
    
    // Focus the new label input
    const newItem = this.containerTarget.lastElementChild
    const labelInput = newItem.querySelector('input[type="text"]')
    if (labelInput) {
      labelInput.focus()
    }
  }

  remove(event) {
    event.preventDefault()
    
    const item = event.target.closest('.custom-link-item')
    if (item) {
      item.remove()
      this.reindex()
      this.updateEmptyState()
    }
  }

  reindex() {
    const items = this.containerTarget.querySelectorAll('.custom-link-item')
    items.forEach((item, index) => {
      const inputs = item.querySelectorAll('input')
      inputs.forEach(input => {
        const name = input.getAttribute('name')
        if (name) {
          input.setAttribute('name', name.replace(/\[\d+\]/, `[${index}]`))
        }
      })
    })
  }

  updateEmptyState() {
    if (this.hasEmptyStateTarget) {
      const hasItems = this.containerTarget.querySelectorAll('.custom-link-item').length > 0
      this.emptyStateTarget.style.display = hasItems ? 'none' : 'block'
    }
  }
}

